import { Alert } from '@mui/material';
import { useState } from 'react';

interface MaintenanceAlertProps {
  leftOffset?: number | string;
}

const MaintenanceAlert = ({ leftOffset = 0 }: MaintenanceAlertProps) => {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <Alert
      severity="warning"
      onClose={() => setOpen(false)}
      sx={{
        borderRadius: 0,
        position: 'fixed',
        top: 0,
        left: leftOffset,
        right: 0,
        zIndex: theme => theme.zIndex.appBar - 1,
      }}
    >
      You may experience disruption to services. We are currently working on
      system maintenance that will be concluded shortly
    </Alert>
  );
};

export default MaintenanceAlert;
